import { render, staticRenderFns } from "./usereditor.vue?vue&type=template&id=35cc0c5c&lang=pug"
import script from "./usereditor.vue?vue&type=script&lang=js"
export * from "./usereditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports